/** Console v0.5: Agents (design brief v0.5, the Agents mock-up). Static for this release (session A: no agent data
 * to count), so there are no per-agent figures, and each agent says honestly whether it's live: only Meeting notes
 * runs today; the rest are "Coming soon" (claims only what's live, CLAUDE.md). */

import type { ScreenContext } from "./app.js";
import { SCREENS } from "./app.js";
import { AGENTS, AGENT_STEPS, AGENTS_INTRO, agentState } from "./agents-logic.js";
import { h, legalFooter, pageHead, tag, uid } from "./ui.js";

function agents(ctx: ScreenContext): void {
  const steps = h("ol", "pk5-steps");
  steps.setAttribute("aria-label", "How agents work");
  AGENT_STEPS.forEach((s, i) =>
    steps.append(h("li", "pk5-step", h("span", "pk5-step-n pk5-figure", String(i + 1)), h("span", "pk5-step-text", h("span", "pk5-step-label", s.label), h("span", "pk5-muted", s.hint))))
  );
  const id = uid("pk5-ag-h");
  const heading = h("h2", "pk5-section-title", "Agents");
  heading.id = id;
  const grid = h("div", "pk5-agent-grid");
  for (const a of AGENTS) {
    const state = agentState(a.key, ctx.me.meetings_enabled === true);
    grid.append(
      h(
        "article",
        "pk5-agent",
        h("div", "pk5-agent-head", h("span", "pk5-agent-name", h("span", "pk5-agent-ini", a.name.charAt(0)), h("h3", "pk5-service-name", a.name)), tag(state, state === "Live" ? "good" : "neutral")),
        h("p", "pk5-agent-does", a.does)
      )
    );
  }
  const section = h("section", "pk5-agents", heading, grid);
  section.setAttribute("aria-labelledby", id);
  ctx.root.append(pageHead("Your AI finance staff", AGENTS_INTRO), steps, section, legalFooter());
}

SCREENS.agents = agents;
